<template>
  <div class="cont">
    <!-- 头部整体盒子 PC端-->
    <div id="header" class="container-fuild">
      <!-- 字体logo -->
      <div class="header_logo" @click="goHome">
        <img src="@/assets/img/logo.png" alt="" srcset="" />
      </div>
      <!-- 新版旧版切换 -->
      <!-- <div class="oldNewSwitch">
        <div class="swithc-item new">新版</div>
        <div class="swithc-item old">
          <a @click="noOld">旧版</a>
          <!-- href="http://www.chinajiemuku.com/cloud/login.html" target="target" -->
        <!-- </div>
        </div>
      </div> -->
      <!-- 搜索 -->
      <div class="search">
        <input
          type="text"
          v-model="search"
          class="seach-input"
          @keydown.enter="SearchVal"
          @focus="showHis"
          @blur="hideHis"
          placeholder="请输入您要搜索的作品"
          ref="shearchInput"
        />
        <div class="search-icon" @click="SearchVal">
          <img src="@/assets/img/seach-icon.png" alt="" srcset="" />
        </div>

        <div
          class="history"
          v-show="historyVis && history.length > 0"
          v-loading="historyLoading"
          @mousedown="preventBlur($event)"
        >
          <div class="title">
            <span>历史记录</span>
            <span class="clear" @click="clear">清楚记录</span>
          </div>
          <div
            class="history-item"
            v-for="(item, index) in history"
            :key="index"
            @click="saveSearch(item)"
          >
            {{ item }}
          </div>
        </div>
      </div>
      <div class="userdropDown">
        <el-popover
          placement="top-start"
          width="200"
          trigger="hover"
          v-if="id && name"
        >
          <div class="down">
            <div class="down-item" @click="$router.push('/uploading')">
              上传作品
            </div>
            <div class="down-item" @click="$router.push('/userCenter')">
              基本信息
            </div>
            <div class="down-item" @click="pushWork">作品管理</div>
            <div class="down-item" @click="logoutHandle()">退出登录</div>
          </div>
          <div slot="reference" class="userdropCont">
            <div class="photo">
              <img src="~@/assets/img/userLogo.png" alt="" srcset="" />
            </div>
            <div class="name" v-if="id && name">{{ name || "暂无" }}</div>
          </div>
        </el-popover>
        <div class="name" v-else>暂未登录</div>
      </div>
    </div>

    <!-- 头部 移动端 -->
    <div id="header-mobile">
      <div class="header-cont">
        <!-- 字体logo -->
        <div class="header_logo" @click="goHome">
          <img src="@/assets/img/logo.png" alt="" srcset="" />
        </div>
        <!-- 搜索 -->
        <div class="search">
          <input
            type="text"
            v-model="search"
            class="seach-input"
            @keydown.enter="SearchVal"
            placeholder="搜索"
          />
          <div class="search-icon" @click="SearchVal">
            <img src="@/assets/img/seach-icon.png" alt="" srcset="" />
          </div>
        </div>
        <div class="userdropDown">
          <div class="photo" @click="$router.push('/userCenter')">
            <img src="~@/assets/img/userLogo.png" alt="" srcset="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { clearLoginInfo } from "@/utils";
import { searchHistory } from "@/api/api";
import homePage from "@/view/home/homePage";
export default {
  name: "Header",
  data() {
    return {
      search: sessionStorage.getItem("searchText") || "",
      searchTextVis: false,
      id: localStorage.getItem("id"),
      name: localStorage.getItem("name"),
      historyVis: false,
      history: [],
      historyLoading: false,
    };
  },
  mounted() {
    this.$root.eventHub.$on("clearSeartch", this.clearSeartch);
    this.$root.eventHub.$on("resetName", this.resetName);
    // this.searchHistory()
    if (JSON.parse(localStorage.getItem("headerHistoryList"))) {
      let history = JSON.parse(localStorage.getItem("headerHistoryList"));
      this.history = history.slice(0, 5);
    }
  },
  beforeDestroy() {
    this.$root.eventHub.$off("clearSeartch");
    this.$root.eventHub.$off("resetName");
  },
  methods: {
    // 清楚历史记录
    clear() {
      this.history = [];
      localStorage.setItem("headerHistoryList", []);
    },

    resetName(data) {
      this.name = data;
    },

    // 获取历史记录
    searchHistory() {
      this.historyLoading = true;
      searchHistory({
        page: 1,
        pageSize: 5,
      }).then(({ data }) => {
        if (data.code == 0 || data.code == 200) {
          this.history = data.t;
          this.historyLoading = false;
        }
      });
    },

    clearSeartch(val) {
      this.name = val;
    },

    // 隐藏
    hideHis() {
      this.historyVis = false;
    },

    // 获取

    // 显示历史记录
    showHis() {
      this.historyVis = true;
    },

    // 去往首页并重置筛选条件
    goHome() {
      this.$emit("resetForm");
      sessionStorage.setItem("searchText", "");
      sessionStorage.setItem("typeId", []);
      sessionStorage.setItem("tagId", []);
      sessionStorage.setItem("oneID", null);
      sessionStorage.setItem("tagName", []);
      sessionStorage.setItem("isOpt", false);
      this.search = "";

      this.$router.push("/home");
    },

    // 不能跳转老项目
    noOld() {
      this.$message.warning("系统维护中，暂时无法访问");
    },

    // 清楚搜索内容
    clearSeartch() {
      this.search = "";
    },

    // 鼠标点击显示搜索按钮
    seachFocus(e) {
      this.searchTextVis = true;
    },

    seachBlur(e) {
      this.searchTextVis = false;
    },

    // 跳转到作品管理页
    pushWork() {
      this.$router.push("/WorkManage");
      localStorage.setItem("workPageSize", 1);
      localStorage.setItem("worksName", "");
      localStorage.setItem("tabVal", 1);
    },

    preventBlur(event) {
      event.preventDefault();
    },

    // 搜搜内容
    saveSearch(search) {
      this.search = search;
      this.SearchVal();
      this.historyVis = false;
    },

    // 搜索存储
    get_search() {
      // 没有搜索记录，把搜索值push进数组首位，存入本地
      if (this.search == "") {
        return;
      }
      console.log(45);
      if (!this.history.includes(this.search)) {
        this.history.unshift(this.search);
        console.log(this.history);
        if (this.history.length > 5) {
          this.history.pop();
        }
        localStorage.setItem(
          "headerHistoryList",
          JSON.stringify(this.history.slice(0, 5))
        );
      } else {
        //有搜索记录，删除之前的旧记录，将新搜索值重新push到数组首位
        let i = this.history.indexOf(this.search);
        this.history.splice(i, 1);
        this.history.unshift(this.search);
        if (this.history.length > 5) {
          this.history.pop();
        }
        localStorage.setItem(
          "headerHistoryList",
          JSON.stringify(this.history.slice(0, 5))
        );
      }
    },

    // 搜索内容
    SearchVal(e) {
      sessionStorage.setItem("searchText", this.search);
      this.get_search();
      this.$router.push({
        path: "/home",
        query: {
          searchVal: this.search,
        },
      });

      this.$emit("searchClick", this.search);
    },

    // 退出登录
    // 退出
    logoutHandle() {
      this.$confirm(`确定进行退出登录?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let userId = localStorage.getItem("id");
          this.$websoket(userId).close();
          clearLoginInfo();
          this.$router.push({ name: "login" });
        })
        .catch(() => {});
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Header.vue